import React from 'react';
import JiraForm from '../JiraForm/JiraSubmit/JiraForm';
import { PopoverTypeEnum } from '../Keys/utils/dialog';
import './index.scss';
import { Form } from 'antd';

interface Props {
  visible: boolean;
  popoverType: PopoverTypeEnum;
  position: any;
  openJiraModal?: boolean;
  selectAccident: any;
  closeCallBack: () => void;
}

const PopoverModel = (props: Props) => {
  const [form] = Form.useForm();
  const closeModel = () => {
    props.closeCallBack();
  };

  const triangleStyle = {
    left: '860px',
  };
  return props.visible ? (
    <>
      <div className='work_box'>
        <div className='title'>
          <span>提报缺陷</span>
          <img
            src={require('../../assets/img/views/single/close.png')}
            className='close'
            style={{ cursor: 'pointer' }}
            onClick={closeModel}
          ></img>
        </div>
        <JiraForm
          form={form}
          closePopoverModel={closeModel}
          openJiraModal={props?.openJiraModal}
          selectAccident={props.selectAccident}
        ></JiraForm>
      </div>
      <div className='pop-over-arrow' style={triangleStyle}>
        {' '}
      </div>
    </>
  ) : (
    <></>
  );
};
export default React.memo(PopoverModel);
